import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=68b7b50c&scoped=true"
import script from "./updateDialog.vue?vue&type=script&lang=js"
export * from "./updateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7b50c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b7b50c')) {
      api.createRecord('68b7b50c', component.options)
    } else {
      api.reload('68b7b50c', component.options)
    }
    module.hot.accept("./updateDialog.vue?vue&type=template&id=68b7b50c&scoped=true", function () {
      api.rerender('68b7b50c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcFeedPlantList/updateDialog.vue"
export default component.exports